import { Unsubscribe, UserPreferencesPort } from '@/domains/user-preference/UserPreferencePort'
import { useUserPreferences } from '@/infra/user-preferences/userPreference.store'
import { StoreDto, TeamDto } from '@/infra/api/generated/model'

export const zustandUserPreferencesAdapter: UserPreferencesPort = {
  getStore(): StoreDto | undefined {
    return useUserPreferences.getState().store
  },
  getTeam(): TeamDto | undefined {
    return useUserPreferences.getState().team
  },
  getLanguageId(): number | undefined {
    return useUserPreferences.getState().languageId
  },
  isConfigured: () => {
    const { store, team, languageId } = useUserPreferences.getState()
    return Boolean(store && team && languageId)
  },
  upsertStore: (store) => {
    useUserPreferences.getState().upsertStore(store)
  },
  upsertTeam: (team) => {
    useUserPreferences.getState().upsertTeam(team)
  },
  upsertLanguageId: (languageId) => {
    useUserPreferences.getState().upsertLanguageId(languageId)
  },
  subscribe: (listener) => {
    return useUserPreferences.subscribe(() => {
      listener()
    }) as Unsubscribe
  },
}
